export default __webpack_public_path__ + "static/media/gallery_00.a94a5684.jpg";